import { render, staticRenderFns } from "./BaseLogin.vue?vue&type=template&id=1375d97e&"
import script from "./BaseLogin.vue?vue&type=script&lang=ts&"
export * from "./BaseLogin.vue?vue&type=script&lang=ts&"
import style0 from "./BaseLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports